import React from 'react'

const DropInputSvg: React.FC<{
    width?: string | number
    height?: string | number
    text: string
}> = ({ width, height, text }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 96 96" fill="none">
            <path
                d="M67.75 51H32C25.9225 51 21 46.0775 21 40C21 34.3625 25.2075 29.66 30.79 29.0825L33.7325 28.78L35.1075 26.1675C37.72 21.135 42.835 18 48.5 18C55.705 18 61.92 23.115 63.3225 30.1825L64.1475 34.3075L68.355 34.61C72.645 34.885 76 38.4875 76 42.75C76 47.2875 72.2875 51 67.75 51Z"
                fill="#FCFCFC"
                stroke="#909090"
                strokeWidth="2"
            />
            <path
                d="M45.1 37.5714H40L48 29L56 37.5714H50.9V44H45.1V37.5714Z"
                stroke="#909090"
                strokeWidth="2"
            />
            <text
                x="48"
                y="70"
                textAnchor="middle"
                fill="#909090"
                fontSize="10"
                fontFamily="Arial, sans-serif"
            >
                {text}
            </text>
        </svg>
    )
}

export default DropInputSvg
